import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverPenaltyEntity } from '../../domain/entities/DriverPenaltyEntity'

export class DriverPenaltyModel extends DriverPenaltyEntity {
  constructor(dataDto: DriverPenaltyEntity) {
    super()
    mapEntityProperties<DriverPenaltyEntity>(this, dataDto)
  }
}
